import React, {useState } from 'react'
import moment from 'moment'
import { Form, Avatar, Table, Modal, Row, Card, Upload, Radio, Col, Button } from 'antd'
import "../../../../../node_modules/react-image-lightbox/style.css";

const UserForm = (props) => {
  const { visible, onCancel, formData } = props
  return (
    <Modal
      visible={visible}
      title='ข้อมูลผู้ใช้'
      footer={null}
      onCancel={onCancel}
    >
      <Row type="flex" gutter={8}>
        <Col>
          <h4>ชื่อ : </h4>
        </Col>
        <Col>
          <div>{formData.name}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>อีเมล : </h4>
        </Col>
        <Col>
          <div>{formData.email}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>เบอร์โทรศัพท์ : </h4>
        </Col>
        <Col>
        <div>{formData.tel ? formData.tel : '-'}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <br></br>
      </Row>
      <Row type="flex" gutter={8} justify="end">
        <Col>
          <Button onClick={() => onCancel()}>ปิด</Button>
        </Col>
      </Row>
    </Modal>
  )
}

const WrappedUserForm = Form.create({
  name: 'UserForm'
})(UserForm)
export default (WrappedUserForm)
